module.exports = __webpack_public_path__ + "img/data-analytic-screen.b48ac65d.svg";